import React, { useState } from 'react'
import PropTypes from 'prop-types'
import './TooltipElement.css'
const TooltipElement = props => {
  return (
    <span
      key={props.color + '-' + props.label}
      className={'toolTipElementContainer'}
    >
      <span
        className={'circle'}
        style={{
          borderColor: props.color,
          backgroundColor: '#fff',
          boxShadow: '0 1px 10px 0 rgba(0, 0, 0, 0.2)'
        }}
      />
      <span className={'tooltipElementLabel'}>{props.label}</span>
    </span>
  )
}
TooltipElement.propTypes = {
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
}
export default TooltipElement
